"use client";

import { buttonVariants } from "@/components/atoms/buttons";
import { useCustomer } from "@/hooks/useCustomer";
import { Locales } from "@/lib/i18n";
import { __, getPermalink } from "@/lib/i18n/functions";
import { cn } from "@/lib/utils";
import Link from "next/link";

type NotLoggedInCardProps = {
  locale: Locales;
};

const NotLoggedInCard = ({ locale }: NotLoggedInCardProps) => {
  const { customer } = useCustomer();

  if (customer !== null) {
    return null;
  }

  return (
    <section className="flex w-full items-center justify-between gap-6 rounded-[10px] bg-[#FFEBF5] p-4 max-md:hidden max-md:flex-col md:p-7.5">
      <h2 className="text-pink-primary font-cabinet-grotesk leading-h1 flex-3/4 text-2xl font-medium md:text-3xl md:leading-9.5 xl:text-3xl">
        {__("Here is your summary. To receive a quote, please log in and complete the following steps.", locale)}
      </h2>
      <div className="flex gap-2.5 max-md:w-full max-md:flex-col">
        <Link
          href={getPermalink(locale, "signup")}
          className={cn(buttonVariants({ variant: "rounded", size: "md" }), "max-sm:w-full max-sm:flex-1")}
        >
          {__("Sign up", locale)}
        </Link>
        <Link
          href={`${getPermalink(locale, "login")}?redirect=${getPermalink(locale, "checkout", "event-info")}`}
          className={cn(buttonVariants({ size: "md" }), "max-sm:w-full max-sm:flex-1")}
        >
          {__("Log in", locale)}
        </Link>
      </div>
    </section>
  );
};

export default NotLoggedInCard;
